import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CompanyHighlights from './components/CompanyHighlights';
import BusinessPillars from './components/BusinessPillars';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import SeoJsonLd from './components/SeoJsonLd';

export default function Home() {
  return (
    <div className="min-h-screen">
      <SeoJsonLd />
      <Header />
      <main>
        <HeroSection />
        <CompanyHighlights />
        <BusinessPillars />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
